export const isLoadingClient = state => state.oauth.client.loading;
export const getClient = state => state.oauth.client.data;
export const getClientError = state => state.oauth.client.error;
export const getAuthorizationCode = state => state.oauth.authorization.code;